import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import styles from "./StoreSearch.module.scss";
import { SearchIcon } from "../../../../assets/icons";
import solarProductService from "../../../../httpService/SolarProductService";
import { toast } from "react-toastify";
import { SolarProduct } from "../../../../model/solar-product/solar-product";
import { useNavigate } from "react-router-dom";

type Props = {
};

const StoreSearch: React.FC<Props> = memo((props: Props) => {
	const [search, setSearch] = useState<string>('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);
	const navigate = useNavigate();

	const [ searchedSolarProducts, setSearchedSolarProducts ] = useState<SolarProduct[]>([]);

	const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
		  setIsOpen(false);
		}
	  };

	const changeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
		setIsOpen(false);
    }

	useEffect(() => {
		// Attach the click event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
		  // Clean up the event listener
		  document.removeEventListener('mousedown', handleClickOutside);
		};
	  }, []);

	useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search])

	const fetchSolarProducts = useCallback(
        async () => {
			if (debouncedSearch == '') return;
            try {
				
                const response = await solarProductService.getbyName(debouncedSearch);

                setSearchedSolarProducts(response.data);
				setIsOpen(true);
            } catch (error) {
                toast.error('There was an error searching Solar Products');
            }
        },
        [debouncedSearch, solarProductService],
    )

	useEffect(() => {
        fetchSolarProducts()
    }, [fetchSolarProducts])
	
	return (
		<div className={styles.container}>
            <SearchIcon />
			<div className={styles.searchAndDropdown}>
				<input type="text" placeholder="Find the package that fits you" className={styles.searchInput} onChange={changeSearch} onFocus={() => setIsOpen(true)}/>
				{
					isOpen && searchedSolarProducts.length > 0 &&
					<div className={styles.dropdownMenu} ref={dropdownRef} >
						{searchedSolarProducts.map(x => 
							<div key={x.id} className={styles.menuItem} onClick={() => {setIsOpen(false); navigate(`/store/item/${x.id}`); }}>
								{x.productName}
							</div>
						)}
					</div>
				} 
			</div>
			<button className={`standardButton ${styles.searchButton}`}>Search</button>
		</div>
	);
});

export default StoreSearch;
